import { db } from "../firebase/config";
import firebase from "firebase/app";

const addViewer = (profileID: string, sessionID: string) => {
  if (profileID && sessionID) {
    db.collection("sessions")
      .doc(sessionID)
      .set(
        {
          viewers: firebase.firestore.FieldValue.arrayUnion(
            db.collection("profiles").doc(profileID)
          ),
        },
        { merge: true }
      );
  }
};

export default addViewer;
